import { render } from "./ProjectCategoryChart.vue?vue&type=template&id=2eb388f2&ts=true"
import script from "./ProjectCategoryChart.vue?vue&type=script&lang=ts"
export * from "./ProjectCategoryChart.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__